<template>
  <div class="common-step fb fb-col relative width-full">
    <div class="step-top width-full">
      <div class="fb fb-cross-center h-18 lh-o1 font-34">
        <slot name="icon"
          ><span
            class="iconfont mr-14"
            :class="ICON_CLASS[icon]"
            v-html="ICON[icon]"
          ></span
        ></slot>
        <slot name="title"></slot>
      </div>
    </div>
    <div class="fb fb-row" style="margin-top: -1px">
      <div class="step-left fb">
        <div class="step-line item-flex-1 fb fb-main-center" v-if="showLine">
          <div class="line"></div>
        </div>
      </div>
      <div class="setp-main">
        <slot name="main"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  components: {},
  props: {
    icon: {
      type: Number,
      default: 0
    },
    showLine: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      ICON: ['&#xe67c;', '&#xe67d;'],
      ICON_CLASS: ['c-006AFE font-32', 'c-171A1D-56 font-34']
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.common-step {
  padding-right: 8px;
  .step-left {
    width: 18px;
    height: inherit;
    .step-line {
      width: 100%;
      .line {
        width: 1px;
        min-height: 40px;
        background: #d8d8d8;
      }
    }
  }

  .setp-main {
    width: 100%;
  }
}
</style>
